export const SUBTITLE_MAX_LENGTH = 2048;
export const SUBTITLE_BE_MAX_LENGTH = 5000;
export const SUBTASK_MAX_LENGTH = 255;
export const DAYS_TO_START_AHEAD_MAX = 100;
export const SHOW_TODO_TASKS_LIMIT = 300;
export const TODO_TASK_PER_PAGE = 10;
export const TITLE_MAX_LENGTH = 255;
export const DEFAULT_TASK_CATEGORY_EMOJI = '📝';
export const DEFAULT_SECONDS_PER_PAGE = 300;

/**
 * How far a session's time per page must be from the book's before the "Time per page" popup asks (Petr, 2026-10-28):
 * it used to ask after any difference at all, even a second a page. The same 20% as category times.
 */
export const PACE_CHANGE_SHARE = 0.2;

/** Whether today's time per page is far enough from the book's to ask about it, faster or slower. */
export const paceDiffersEnough = (newSecondsPerPage: number, secondsPerPage: number | null | undefined) =>
  !secondsPerPage || Math.abs(newSecondsPerPage - secondsPerPage) >= secondsPerPage * PACE_CHANGE_SHARE;
export const PLANNED_TASK_NOTES_MAX_LENGTH = 2048;
export const EMOJI_PICKER = '🥑';

// mark complete animation constants
export const FADE_IN_MOVE_TO_DO_DURATION = 0; // in seconds
// Completing a task in the Task List table (Petr: "a lot more fun", then "more exciting and powerful"): green shoots
// across its row with a bright edge and a burst of sparkles as it lands, holds a moment, the row fades, and the rows below
// slide up over it.
export const TASK_LIST_COMPLETE_SWEEP_MS = 380;
// When the green reaches the far end: it starts fast and eases in, so it is 96% across here, well before the sweep's
// time is up. The sparkles go off now, not at the end of the time, which read as a pause before them (Petr).
export const TASK_LIST_COMPLETE_ARRIVE_MS = 210;
// A moment fully green before the fade. It used to flash brighter here, which felt like something happening twice (Petr).
export const TASK_LIST_COMPLETE_HOLD_MS = 150;
export const TASK_LIST_COMPLETE_FADE_MS = 150;
export const TASK_LIST_COMPLETE_COLLAPSE_MS = 260;
